import { lazy } from 'react'

/**
 * Módulo: Proyectos ("nuestro Asana" dentro de CoWork)
 *
 * Capa de orquestación de trabajo a mediano/largo plazo: proyectos con hitos,
 * equipo, presupuesto y entregables. Agnóstico al tenant (mismo código para
 * trabajo interno de Milbrands y, a futuro, para clientes).
 *
 * Decisiones de arranque: .claude/decisions/018-modulo-proyectos.md
 * Diseño canónico: docs/modulo_proyectos.md
 *
 * Bloque 1 (esqueleto): solo el catálogo + la ruta a una página "Próximamente".
 * El modelo de datos, el ABM y las tareas propias (`tareasProyecto`) llegan en
 * los bloques siguientes.
 */
export default {
  id: 'proyectos',
  nombre: 'Proyectos',
  descripcion: 'Orquestación de proyectos: hitos, equipo, entregables y tareas propias',
  icono: 'kanban',
  tipo: 'core',
  version: '0.1.0',

  // Interno de Milbrands por ahora: agrupa bajo "Milbrands Operaciones" en el
  // sidebar del staff. El día que se abra a clientes, se suma al plan y se le
  // otorga al rol cliente el permiso-módulo 'proyectos' (ADR 018 §2.4).
  milbrandsInterno: true,
  // Visibilidad por rol (#58): el módulo aparece si el usuario tiene 'ver' sobre
  // el permiso-módulo 'proyectos' (o es Wizard, que ve todo el catálogo).
  permisoModulos: ['proyectos'],

  routes: [
    { path: 'proyectos', component: lazy(() => import('./pages/ProyectosPage')) },
    { path: 'proyectos/dashboard', component: lazy(() => import('./pages/ProyectosDashboardPage')) },
    { path: 'proyectos/workload', component: lazy(() => import('./pages/WorkloadPage')) },
    { path: 'proyectos/portfolio', component: lazy(() => import('./pages/PortfolioPage')) },
    { path: 'proyectos/seguimiento', component: lazy(() => import('./pages/SeguimientoPage')) },
    { path: 'proyectos/plantillas', component: lazy(() => import('./pages/PlantillasPage')) },
    { path: 'proyectos/configuracion', component: lazy(() => import('./pages/ConfiguracionProyectosPage')) },
    { path: 'proyectos/:proyectoId', component: lazy(() => import('./pages/ProyectoDetailPage')) },
  ],

  // El Layout agrupa los módulos con `milbrandsInterno: true` bajo el subheader
  // "Milbrands Operaciones" en el sidebar del staff (no en un grupo propio).
  // Ítems mudados el 7-jul: "Proyectos" → grupo SUPERVISIÓN, "Mis proyectos"
  // → grupo GESTIÓN. Las rutas siguen acá (routes), solo se movieron los ítems
  // del menú. Como este módulo es `milbrandsInterno` y ya no aporta ítems, la
  // sección "Milbrands Operaciones" queda con Admin + Documentación (ambos
  // hardcodeados en Layout.jsx > MilbrandsOperacionesSection).
  menuItems: [],
}
